
				var addMethods = require("../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["none"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "498e78225b78f9b51792.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			